module.exports = __webpack_public_path__ + "img/changsan.9829989f.png";